import * as React from "react";
const EquipmentsView = React.lazy(() => import("./EquipmentsViewContainer"));
const EquipmentList = React.lazy(() => import("./EquipmentListContainer"));

export { EquipmentsView, EquipmentList };
